export default function getResource(label) {
    const resources = {
        seeMore: 'See more',
        showMore: 'Show more'
    };
    return resources[label];
}
